export enum NftCardAspectRatioVariant {
  square,
  elongated,
  portrait
}

export enum NftCardInstanceVariant {
  collection,
  item
}
